import {
  EventType,
  AuthError,
  AuthenticationResult,
  InteractionType,
} from "@azure/msal-browser";
import { msalInstance } from "../msal/msalInstance";
import { loginRequest, passwordResetRequest } from "../msal/msalConfig";
import { REDIRECT_ERROR_CODES } from "@/shared/constants";
import {
  completeLoginAttempt,
  hasPendingLogout,
  isPasswordResetAccount,
} from "@/shared/helper/authSession.helper";
import { requestLoginRedirect } from "./authSync";

const redirectToLoginAfterPasswordReset = async (
  result: AuthenticationResult,
): Promise<void> => {
  // Cleanup is best-effort; the user must still be sent back to sign-in.
  await msalInstance
    .clearCache({ account: result.account })
    .catch(() => undefined);
  await requestLoginRedirect(loginRequest);
};

export const registerAuthEvents = (): void => {
  msalInstance.addEventCallback((event) => {
    if (
      event.eventType === EventType.ACQUIRE_TOKEN_FAILURE &&
      event.error instanceof AuthError &&
      event.error.message?.includes(REDIRECT_ERROR_CODES.forgotPassword)
    ) {
      void requestLoginRedirect(passwordResetRequest);
      return;
    }

    if (
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS &&
      (event.interactionType === InteractionType.Redirect ||
        event.interactionType === InteractionType.Popup)
    ) {
      const result = event.payload as AuthenticationResult;

      if (isPasswordResetAccount(result)) {
        void redirectToLoginAfterPasswordReset(result);
        return;
      }
      if (result.account) {
        if (
          hasPendingLogout() &&
          !completeLoginAttempt(result.correlationId)
        ) {
          msalInstance.setActiveAccount(null);
          return;
        }
        msalInstance.setActiveAccount(result.account);
      }
    }
  });
};
